export default __webpack_public_path__ + "2b469cbc0e9b1e9ca8ff26ccf939d0b6.svg";